module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_E.f55fa4c2.mp3";